import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { Box, Typography } from "@mui/material";
import React from "react";

const StepLabel = ({
  title,
  containerStyles,
  onClick,
  useFontSize,
  hideBack,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        ...(containerStyles || {}),
      }}
    >
      {!hideBack && (
        <ArrowBackOutlinedIcon
          sx={{ cursor: "pointer", color: "#0091DA", fontSize: 24 }}
          onClick={onClick}
        />
      )}
      <Typography
        color="secondary"
        sx={{
          fontSize: useFontSize ? useFontSize : "20px",
          fontWeight: "bold",
          lineHeight: 1.4,
          marginLeft: "16px",
          textTransform: "none",
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default StepLabel;
